import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { ContextMenu } from 'components/Menu';

const MOUSE_ENTER_DELAY = 0.885;

const Menu = ({
  children, className, content, data, menuItems, mouseEnterDelay, onContextClick, overlayClassName, style, title, trigger
}) => {
  /**
   * @description Updates the visible state for the PopOver
   * @param {boolean} visible - The visibility of the PopOver
   * @param {function} handleVisibleChange - Visible handler
   */
  const [visible, handleVisibleChange] = useState(false);
  return (
    <ContextMenu data={data} menuItems={menuItems} onContextClick={onContextClick}>
      <Popover
        title={title}
        content={content}
        overlayClassName={overlayClassName}
        trigger={trigger}
        placement="left"
        visible={visible}
        mouseEnterDelay={mouseEnterDelay || MOUSE_ENTER_DELAY}
        onVisibleChange={handleVisibleChange}
      >
        <span
          tabIndex={data.key}
          role="button"
          className={className}
          style={style}
          onMouseUp={() => handleVisibleChange(true)}
          onMouseDown={() => handleVisibleChange(false)}
        >
          {children}
        </span>
      </Popover>
    </ContextMenu>
  );
};

Menu.propTypes = {
  children: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  menuItems: PropTypes.array.isRequired,
  mouseEnterDelay: PropTypes.number,
  onContextClick: PropTypes.func.isRequired,
  overlayClassName: PropTypes.string,
  style: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  trigger: PropTypes.string
};

Menu.defaultProps = {
  mouseEnterDelay: null,
  overlayClassName: 'bhp-timeline-popover',
  trigger: 'hover'
};

export default Menu;
